<script setup>
defineProps(['model'])
</script>

<!-- Testimonial Block -->
<template>
  <div
    v-if="model?.width?.value !== 'full-width'"
    class="testimonial-block testimonial-block--narrow-width mb-(--block-spacing)"
    :class="{ 'testimonial-block--navy': model?.bgColor?.value === 'navy' }"
  >
    <div class="container-fluid">
      <div class="testimonial-block__content-wrap">
        <NuxtImg
          v-if="model?.aprimoTestimonialFeatureImage?.url"
          provider="fastlyAprimo"
          :src="model?.aprimoTestimonialFeatureImage?.url"
          class="rounded-t-xl md:rounded-xl testimonial-block__image"
          :alt="model?.testimonialFeatureImageAltText?.value"
          :width="model.aprimoTestimonialFeatureImage.width ?? 710"
          :height="model.aprimoTestimonialFeatureImage.height ?? 497"
          fit="cover"
          sizes="(max-width: 768px) 100vw, 710px"
        />
        <div class="testimonial-block__testimonial-wrap">
          <div
            class="prose testimonial-block__testimonial card-shadow"
            :class="{ 'dark-bg': model?.bgColor?.value === 'navy' }"
          >
            <div class="testimonial-block__testimonial-quote">
              <img
                class="testimonial-block__quote-icon"
                src="/images/icon-quotes-open.svg"
                alt=""
              >
              <div
                v-if="model?.pullQuote?.value"
                v-html="model.pullQuote.value"
              />
              <div
                v-else
                class="lead-in"
                v-html="model?.quote?.value"
              />
              <img
                class="testimonial-block__quote-icon"
                src="/images/icon-quotes-close.svg"
                alt=""
              >
            </div>
            <p class="italic testimonial-block__speaker">
              {{ `- ${model?.attribution?.value}` }}
            </p>
          </div>
          <ULink
            v-if="model.callToAction?.value"
            :to="useCmsUrl(model.callToAction.value?.href)"
            :locale="false"
          >
            <UButton
              v-if="model?.callToAction?.value"
              color="info"
              variant="solid"
              class="btn w-3/4 sm:w-auto cursor-pointer"
            >
              {{ model?.callToAction?.value?.text }}
            </UButton>
          </ULink>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else-if="model?.width.value === 'full-width'"
    class="testimonial-block testimonial-block--full-width mb-(--block-spacing)"
    :class="{ 'testimonial-block--navy': model?.bgColor?.value === 'navy' }"
  >
    <div class="container-fluid">
      <div class="testimonial-block__content-wrap">
        <NuxtImg
          v-if="model?.aprimoTestimonialFeatureImage?.url"
          provider="fastlyAprimo"
          :src="model?.aprimoTestimonialFeatureImage?.url"
          class="rounded-t-xl md:rounded-xl testimonial-block__image"
          :alt="model?.testimonialFeatureImageAltText?.value"
          :width="model.aprimoTestimonialFeatureImage.width ?? 710"
          :height="model.aprimoTestimonialFeatureImage.height ?? 497"
          fit="cover"
          sizes="(max-width: 768px) 100vw, 710px"
        />
        <div class="testimonial-block__testimonial-wrap">
          <div
            class="prose testimonial-block__testimonial card-shadow"
            :class="{ 'dark-bg': model?.bgColor?.value === 'navy' }"
          >
            <div class="testimonial-block__testimonial-quote">
              <img
                class="testimonial-block__quote-icon"
                src="/images/icon-quotes-open.svg"
                alt=""
              >
              <div
                v-if="model?.pullQuote?.value"
                v-html="model.pullQuote.value"
              />
              <div
                v-else
                class="lead-in"
                v-html="model?.quote?.value"
              />
              <img
                class="testimonial-block__quote-icon"
                src="/images/icon-quotes-close.svg"
                alt=""
              >
            </div>
            <p class="italic testimonial-block__speaker">
              {{ `- ${model?.attribution?.value}` }}
            </p>
          </div>
          <ULink
            v-if="model.callToAction?.value"
            :to="useCmsUrl(model.callToAction.value.href)"
            :locale="false"
          >
            <UButton
              v-if="model?.callToAction?.value"
              color="info"
              variant="solid"
              class="btn w-full sm:w-auto justify-center cursor-pointer"
            >
              {{ model.callToAction.value.text }}
            </UButton>
          </ULink>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/blocks/testimonial-block.scss';
</style>
